import ABout from "../components/about/about";
import Choose from "../components/choose/choose";
function ABoutpage(){
    return(
        <>
        <ABout/>
      <Choose/>
        </>
    )
}
export default ABoutpage